import formatTableJson from '@/config/tableComponentParams.js'
import { PUBLISHStatus } from '@/config/status'
import { publishStatusTag } from '@/config/tag.js'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'iconBig',
    label: i18n.t('RecipeManage.listRecipeImg'),
    type: 'image'
  },
  {
    filed: 'name',
    label: i18n.t('RecipeManage.listRecipeName'),
    width: '180px',
    showOverflowTooltip: true
  },
  // {
  //   filed: 'code',
  //   label: i18n.t('RecipeManage.listRecipeId'),
  //   width: '180px',
  //   showOverflowTooltip: true
  // },
  {
    filed: 'productNames',
    label: i18n.t('RecipeManage.listApplicableModel'),
    width: '180px',
    showOverflowTooltip: true,
    formatFn: function(_, row) {
      return row.productNames.join()
    }
  },
  {
    filed: 'typeName',
    label: i18n.t('RecipeManage.listRecipeType'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'downloadCount',
    label: i18n.t('Common.downTimes'),
    width: '180px',
    sortable: true,
    showOverflowTooltip: true
  },
  {
    filed: 'collectCount',
    label: i18n.t('RecipeManage.listCollectionTimes'),
    width: '180px',
    sortable: true,
    showOverflowTooltip: true
  },
  {
    filed: 'state',
    label: i18n.t('RecipeManage.listPublishStatus'),
    type: 'tag',
    colorList: publishStatusTag,
    formatFn: function(_, row) {
      return i18n.t(`RecipeManage.list${row.state}`)
    }
  },
  {
    filed: 'createUserName',
    label: i18n.t('RecipeManage.listCreateUser'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'updateTime',
    label: i18n.t('RecipeManage.listUpdateTime'),
    type: 'time',
    sortable: true,
    width: '180px',
    showOverflowTooltip: true
  }
])
